import styled from 'styled-components'

export const StyledSpecsReportNavMenu = styled.div`
  .jato-nav-item > :first-child {
    padding-bottom: 6px;
  }
`
